import { render, staticRenderFns } from "./IconProsegur.vue?vue&type=template&id=0bfae364&"
import script from "./IconProsegur.vue?vue&type=script&lang=ts&"
export * from "./IconProsegur.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports